import { render, staticRenderFns } from "./myKeyWord.vue?vue&type=template&id=54243e65&scoped=true"
import script from "./myKeyWord.vue?vue&type=script&lang=js"
export * from "./myKeyWord.vue?vue&type=script&lang=js"
import style0 from "./myKeyWord.vue?vue&type=style&index=0&id=54243e65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54243e65",
  null
  
)

export default component.exports